import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";
import loader from "../../style/loader/loader.scss";
import DatePicker from "react-date-picker";
import { renderAlert, clearAlert } from "../../redux/actions/alertsActions";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import {
  addInvoices,
  getInvoicesDetails,
  updateInvoices,
  getSiteList,
  get_site_details_id
} from "../../redux/actions/invoicesActions";

import AdditionalPrice from "./AdditionalPrice";

import NumberFormat from "react-number-format";

let xCoordinate = {},
yCoordinate = {};

const history = createHashHistory();
const HorizontalLine = ({}) => <hr />;

const propTypes = {
};

let isLoading = "false";
let priceIndex = 0;
let form = [];
let invoiceDescription = [],
  r_invoiceDescription = [],
  invoiceQuantity = [],
  invoicePrice = [],
  totalInvoiceAmt = [],
  invoicesID = [];
let additionalPriceDetail = [],
  invoicesIdParams,
  invoices;

class AddInvoices extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Invoices", "Add Invoices"],
      links: ["home","Invoices","AddInvoices"],
      invoicesID: "",
      invoiceDescription: "",
      invoiceQuantity: "",
      invoicePrice: "",  
      totalInvoiceAmt: "",  
      alertMessage: "", 
      disabled: false,
      submitValue: "Save",
      show: false,
      clearAttributes: false,      
      hideMsg: false,
      msgType: "",
      siteList: [],
      priceIndex: [],
      isLoading: false,
      deatil: "",
      defaultDisabled:"",
      save:"",
    };

    // this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDraft = this.handleDraft.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.addPricingDetail = this.addPricingDetail.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
  }
  /*
   * Start multiple price management
   */

  addPricingDetail = e => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        handleinvoiceDescriptionChange={this.handleinvoiceDescriptionChange}
        handleinvoiceQuantityChange={this.handleinvoiceQuantityChange}
        handleinvoicePriceChange={this.handleinvoicePriceChange}
        handletotalInvoiceAmtChange={this.handletotalInvoiceAmtChange}
        priceData=""
        validationError={this.state.additionalError}
        key={Math.random()}
      />
    ); 
    this.setState({ priceIndex: form });
  };

  editPricingDetail = data => {
    priceIndex = priceIndex + 1;
    form[priceIndex] = (
      <AdditionalPrice
        key={Math.random()}
        removePriceDetail={this.removePriceDetail}
        indexKey={priceIndex}
        handleinvoiceDescriptionChange={this.handleinvoiceDescriptionChange}       
        handleinvoiceQuantityChange={this.handleinvoiceQuantityChange}
        handleinvoicePriceChange={this.handleinvoicePriceChange}  
        handletotalInvoiceAmtChange={this.handletotalInvoiceAmtChange}      
        priceData={data}
        handleUpdate={this.handleUpdate}
        validationError={this.state.additionalError}
        key={Math.random()}
      />
    );
    r_invoiceDescription[priceIndex] = data.invoiceDescription;
    this.setState({ priceIndex: form });
  };

  handleUpdate = (field, value, index, invoicesID) => {

    let newIdx = index - 1;
   
    const newInvoices = this.state.invoices.map((data, pidx) => {
      if (newIdx != pidx) return data;
      return { ...data, [field]: value, totalInvoiceAmt : ((field == 'invoiceQuantity') ? value * data['invoicePrice'] : ((field == 'invoicePrice') ? value * data['invoiceQuantity'] : data['totalInvoiceAmt'])) };
    });
    this.setState({ invoices: newInvoices });
  };

    handleChangeCompany(e) {

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      invoiceCountry: "",      
      invoiceState: "",
      invoiceCity: "",
      invoiceAddress1: "",
      invoiceAddress2: "",
    });
    this.props.get_site_details_id(e.target.value);
  }

  handleChangeAditionalPrice = e => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "invoiceDescription") {
      this.handleinvoiceDescriptionChange(e.target.value, 0);
    }
    if (e.target.name == "invoiceQuantity") {
      const tAmount = e.target.value * this.state.invoicePrice;
      this.setState({totalInvoiceAmt : tAmount});
      this.handletotalInvoiceAmtChange(tAmount, 0);
      this.handleinvoiceQuantityChange(e.target.value, 0);
    }
    if (e.target.name == "invoicePrice") {
      const tAmount = e.target.value * this.state.invoiceQuantity;
      this.setState({totalInvoiceAmt : tAmount});
      this.handletotalInvoiceAmtChange(tAmount, 0);
      this.handleinvoicePriceChange(e.target.value, 0);
    }
    if (e.target.name == "totalInvoiceAmt") {
      this.handletotalInvoiceAmtChange(this.state.totalInvoiceAmt, 0);
    }

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  };

  removePriceDetail = (id, invoicesID) => {
    if(invoicesID != ''){
      let newID = id - 1;
      let invoicesData = this.state.invoices;
      delete invoicesData[newID];
      this.setState({ invoices: invoicesData });

      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });
    }else{
      let priceIndex = this.state.priceIndex;
      delete priceIndex[id];
      this.setState({ priceIndex: priceIndex });
      delete invoiceDescription[id];
      delete invoiceQuantity[id];
      delete invoicePrice[id];
      delete totalInvoiceAmt[id];
      delete priceIndex[id];
    }
  };

  handleinvoicesIDChange = (data, idx) => {
    invoicesID[idx] = data;
  };


  handleinvoiceDescriptionChange = (invoiceDescriptionData, idx) => {
    invoiceDescription[idx] = invoiceDescriptionData;
    r_invoiceDescription[idx] = invoiceDescriptionData;    
  };
  
  handleinvoiceQuantityChange = (invoiceQuantityData, idx) => {
    invoiceQuantity[idx] = invoiceQuantityData;
  };
  handleinvoicePriceChange = (invoicePriceData, idx) => {
    invoicePrice[idx] = invoicePriceData;
  };
  handletotalInvoiceAmtChange = (totalInvoiceAmtData, idx) => {
    totalInvoiceAmt[idx] = totalInvoiceAmtData;
  };

  /*
   * End multiple price management
   */

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }


  // Handle input onchange
  handleChange(e) {
    this.setState({ disabled: false });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  }

  handleValidation() {
    let formIsValid = true;
    this.state.invoiceDescriptionError = false;
    this.state.invoiceQuantityError = false;
    this.state.invoicePriceError = false;
    this.state.totalInvoiceAmtError = false;
    this.state.siteIDError = false;
    if (!this.state.invoiceDescription) {
      formIsValid = false;
      this.setState({
        invoiceDescriptionError: "red"
      });
    }
    if (!this.state.invoiceQuantity) {
      formIsValid = false;
      this.setState({
        invoiceQuantityError: "red"
      });
    }
    if (!this.state.invoicePrice) {
      formIsValid = false;
      this.setState({
        invoicePriceError: "red"
      });
    }
    if (!this.state.totalInvoiceAmt) {
      formIsValid = false;
      this.setState({
        totalInvoiceAmtError: "red"
      });
    }
    if (!this.state.siteID) {
      formIsValid = false;
      this.setState({
        siteIDError: "red"
      });
    }
    return formIsValid;
  }

  additionalPrice = () => { 
    additionalPriceDetail = [];
    let constAdditionalData;
    // invoicesID
    if (invoicesIdParams == "" || invoicesIdParams == "undefined") {
      for (let i = 0; i < r_invoiceDescription.length; i++) { 
        if(typeof r_invoiceDescription[i] != 'undefined' && r_invoiceDescription[i]!='' && typeof invoiceDescription[i] != 'undefined' && invoiceDescription[i]!=''){
          constAdditionalData = {
            invoiceDescription: invoiceDescription[i] ? invoiceDescription[i] : "",            
            invoiceQuantity: invoiceQuantity[i] ? invoiceQuantity[i] : "",
            invoicePrice: invoicePrice[i] ? invoicePrice[i] : "",
            totalInvoiceAmt: totalInvoiceAmt[i] ? totalInvoiceAmt[i] : "",
          };
          additionalPriceDetail.push(constAdditionalData);
        }
      }
    } else {
      for (let i = 0; i < invoiceDescription.length; i++) {
        if(typeof invoiceDescription[i] != 'undefined' && invoiceDescription[i]!=''){
          constAdditionalData = {
            invoicesID: invoicesID[i] ? invoicesID[i] : "",
            invoiceDescription: invoiceDescription[i] ? invoiceDescription[i] : "",
            invoiceQuantity: invoiceQuantity[i] ? invoiceQuantity[i] : "",
            invoicePrice: invoicePrice[i] ? invoicePrice[i] : "",
            totalInvoiceAmt: totalInvoiceAmt[i] ? totalInvoiceAmt[i] : "",
          };
          additionalPriceDetail.push(constAdditionalData);        
        }
      }
      if (this.state.invoices) {
        this.state.invoices.map((data, i) =>{       
            additionalPriceDetail.push(data);            
        });
      }
    }
    this.setState({ deatil: additionalPriceDetail });
    return additionalPriceDetail;
  };

  handleSubmit(e) {
    e.preventDefault();
    const additionalPrice = this.additionalPrice();
    
    if (this.handleValidation()) {
      this.setState({ disabled: true, isLoading: true });
      if (this.state.invoicesID !== "") {
        if (invoicesIdParams !== "") { 
           const updateData = {     
            siteID: this.state.siteID,
            invoiceID: this.state.invoicesID,
            invoiceCountry: this.state.invoiceCountry,      
            invoiceState: this.state.invoiceState,
            invoiceCity: this.state.invoiceCity,
            invoiceAddress1: this.state.invoiceAddress1,
            invoiceAddress2: this.state.invoiceAddress2,
            detail: additionalPrice,
            save: 1,
          };
          //console.log('updateData', updateData);
          this.props.updateInvoices(updateData);
        }
      } else {
        const postData = {
          siteID: this.state.siteID,
          invoiceCountry: this.state.invoiceCountry,      
          invoiceState: this.state.invoiceState,
          invoiceCity: this.state.invoiceCity,
          invoiceAddress1: this.state.invoiceAddress1,
          invoiceAddress2: this.state.invoiceAddress2,
          detail: additionalPrice,
          save: 1,
        };
        //console.log('postData', postData);
        this.props.addInvoices(postData);
      }
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
    }
  }

  handleDraft(e) {
    e.preventDefault();
    const additionalPrice = this.additionalPrice();
    
    if (this.handleValidation()) {
      this.setState({ disabled: true });
      if (this.state.invoicesID !== "") {
        if (invoicesIdParams !== "") {
           const updateData = {     
            siteID: this.state.siteID,
            invoiceID: this.state.invoicesID,
            invoiceCountry: this.state.invoiceCountry,      
            invoiceState: this.state.invoiceState,
            invoiceCity: this.state.invoiceCity,
            invoiceAddress1: this.state.invoiceAddress1,
            invoiceAddress2: this.state.invoiceAddress2,
            detail: additionalPrice,
            save: 0,
          };
          //console.log('updateData', updateData);
          this.props.updateInvoices(updateData);
        }
      } else {
        const postData = {
          siteID: this.state.siteID,
          invoiceCountry: this.state.invoiceCountry,      
          invoiceState: this.state.invoiceState,
          invoiceCity: this.state.invoiceCity,
          invoiceAddress1: this.state.invoiceAddress1,
          invoiceAddress2: this.state.invoiceAddress2,
          detail: additionalPrice,
          save: 0,
        };
        //console.log('postData', postData);
        this.props.addInvoices(postData);
      }
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
    }
  }

  Clear() {      
      (this.state.invoiceDescription = ""),      
      (this.state.invoiceQuantity = ""),
      (this.state.invoicePrice = ""),
      (this.state.totalInvoiceAmt = ""),
   
      additionalPriceDetail = [];
      priceIndex = 0;
      priceIndex = [];
      invoiceDescription = [];
      invoiceQuantity = [];
      invoicePrice = [];
      totalInvoiceAmt = [];
      form = [];
      this.state.priceIndex = [];
  }

  componentWillMount() {
    invoiceDescription = [];
    r_invoiceDescription = [];
    priceIndex = 0;
    form = [];
    additionalPriceDetail = [];
    this.handleDismiss();

    let invoicesIdParams = this.props.match.params.invoicesId
      ? this.props.match.params.invoicesId
      : "";

    if (invoicesIdParams !== "") {
      const editLink = `AddInvoices/${invoicesIdParams}`
      this.props.getInvoicesDetails(invoicesIdParams);
      this.state.path = ["Home", "Invoices", "Edit Invoices"];
      this.state.links = ["home","invoices",editLink];
    }

    this.props.getSiteList({page: 0});
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.fetchInvoices !== nextProps.fetchInvoices) {
      this.setState({ isLoading: nextProps.fetchInvoices });
    }

    if(this.props.siteList !== nextProps.siteList){
      if(nextProps.siteList){
        this.setState({
          sitedata: nextProps.siteList,
          siteList: nextProps.siteList
        })
      }
    }  

    if (this.props.siteDetails !== nextProps.siteDetails) {
      if (nextProps.siteDetails) {
        this.setState({
          invoiceCountry: nextProps.siteDetails.userCountry,
          invoiceState: nextProps.siteDetails.userState,
          invoiceCity: nextProps.siteDetails.city,
          invoiceAddress1: nextProps.siteDetails.address1,
          invoiceAddress2: nextProps.siteDetails.address2
        });
      }
    }

    if (this.props.addInvoicesResponse !== nextProps.addInvoicesResponse) {
      if (nextProps.addInvoicesResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.addInvoicesResponse.message
        );
        this.setState({ disabled: false, isLoading: false });
        isLoading = "false";
        this.state.clearAttributes = true;
        this.Clear();
      }
      window.scrollTo(0, 0);
    }

    if (this.props.updatedInvoices !== nextProps.updatedInvoices) {
      if (nextProps.updatedInvoices) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedInvoices.message);
        this.setState({ disabled: false, isLoading: false });
        isLoading = "false";
        this.Clear();
        this.state.clearAttributes = true;
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        window.scrollTo(0, 0);
        this.setState({ disabled: false, isLoading: false, alertMessage: nextProps.error, msgType: "warning", show: true });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }

    if (this.props.invoicesDetails !== nextProps.invoicesDetails) {

      if (nextProps.invoicesDetails) {
        priceIndex = [];
        isLoading = "false";
        this.setState({ invoicesDetailsForEdit: nextProps.invoicesDetails.data });
        let invoicesDetails = nextProps.invoicesDetails.data;
        let parent = {};
        this.setState({ defaultDisabled : 'disabled' });
        if(invoicesDetails.child_invoices && invoicesDetails.child_invoices[0]) {
          parent = invoicesDetails.child_invoices;
          parent = parent.splice(0, 1);
        }
        this.setState({
          invoicesID: invoicesDetails.id,
          siteID: invoicesDetails.siteID,
          invoiceCountry: invoicesDetails.invoiceCountry,      
          invoiceState: invoicesDetails.invoiceState,
          invoiceCity: invoicesDetails.invoiceCity,
          invoiceAddress1: invoicesDetails.invoiceAddress1,
          invoiceAddress2: invoicesDetails.invoiceAddress2,
          invoiceDescription: invoicesDetails.invoiceDescription,
          invoiceQuantity: invoicesDetails.invoiceQuantity,
          invoicePrice: invoicesDetails.invoicePrice,
          totalInvoiceAmt: invoicesDetails.totalInvoiceAmt,
          invoices: invoicesDetails.child_invoices,
        });
        
        if (!isEmpty(invoicesDetails.child_invoices)) {
          invoiceDescription = [];
          r_invoiceDescription = [];
          invoiceQuantity = [];
          invoicePrice = [];
          totalInvoiceAmt = [];
          priceIndex = 0;
          form = [];
          additionalPriceDetail = [];
          invoicesDetails.child_invoices.map((data, index) =>
            this.editPricingDetail(data)
          );
        }
        if (parent[0].invoicesID) {
          this.handleinvoicesIDChange(parent[0].invoicesID, 0);
        }
        if (parent[0].invoiceDescription) {
          this.handleinvoiceDescriptionChange(parent[0].invoiceDescription, 0);
        }
        if (parent[0].invoiceQuantity) {
          this.handleinvoiceQuantityChange(parent[0].invoiceQuantity, 0);
        }
        if (parent[0].invoicePrice) {
          this.handleinvoicePriceChange(parent[0].invoicePrice, 0);
        }
        if (parent[0].totalInvoiceAmt) {
          this.handletotalInvoiceAmtChange(parent[0].totalInvoiceAmt, 0);
        }
      }
    }
  }

  handleChangeCompany(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      invoiceCountry: "",      
      invoiceState: "",
      invoiceCity: "",
      invoiceAddress1: "",
      invoiceAddress2: "",
    });
    this.props.get_site_details_id(e.target.value);
  }

  getValidationinvoiceDescription() {
    const length = this.state.invoiceDescription.length;
    if (length < 2) return "error";
    return null;
  }

  getValidationinvoiceQuantity() {
    const length = this.state.invoiceQuantity.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationoinvoicePrice() {
    const length = this.state.invoicePrice.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  getValidationtotalInvoiceAmt() {
    const length = this.state.totalInvoiceAmt.length;
    if (length >= 1) return "success";
    else if (length > 0) return "error";
    return null;
  }

  render() {
    let invoices =
      this.props.invoicesDetails 
        ? this.props.invoicesDetails
        : {};

    let siteListData = this.state.siteList
      ? this.state.siteList
      : [];

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.props.sendingSiteDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.show &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
            <Alert
            bsStyle={this.state.msgType}
            onDismiss={this.handleDismiss}
            >
            <strong className="alert-msg-type">
            {this.state.msgType}:
            </strong>{" "}
            {this.state.alertMessage}
            </Alert>
            </div>
            )}
        {this.state.isLoading ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
        <form>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
        {/**start Company information **/}

          <div className="panel">
            <header className="panel-heading">Company Information</header>
            <div className="panel-body">
              <div className="add-invoices col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={4} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Company Name
                    </ControlLabel>
                   <FormGroup
                      controlId="formCompanyID"
                    >
                      <FormControl
                        componentClass="select"
                        name="siteID"
                        onChange={this.handleChangeCompany}
                        value={this.state.siteID}
                        style={{ borderColor: this.state.siteIDError }}
                        disabled = {this.state.defaultDisabled ? "disabled" : ""}
                      >
                        <option value="">Choose Company Name</option>
                        {siteListData.map((el, key) => {
                          return (
                            <option key={key} value={el.siteID}>
                              {el.siteName}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formBasicInvoiceCityText">
                      <ControlLabel>City</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceCity ? this.state.invoiceCity : ""}
                        placeholder="Enter City"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.invoiceCityError }}
                        name="invoiceCity"
                        readOnly = "true"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4} xs={12}>
                    <div className="form-group" id="primaryContactInfoCountry">
                    <FormGroup controlId="formBasicInvoiceCountryText">
                      <ControlLabel>Country</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceCountry ? this.state.invoiceCountry : ""}
                        placeholder="Enter Country"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.invoiceCountryError }}
                        name="invoiceCountry"
                        readOnly = "true"
                      />
                    </FormGroup>
                    </div>
                    <FormGroup controlId="formInvoiceAddress1">
                      <ControlLabel>Address 1</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceAddress1 ? this.state.invoiceAddress1 : ""}
                        placeholder="Address 1"
                        onChange={this.handleChange}
                        name="invoiceAddress1"
                        readOnly = "true"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4} xs={12}>
                  <FormGroup controlId="formBasicInvoiceStateText">
                      <ControlLabel>State</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceState ? this.state.invoiceState : ""}
                        placeholder="Enter State"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.invoiceStateError }}
                        name="invoiceState"
                        readOnly = "true"
                      />
                    </FormGroup>
                  <FormGroup controlId="formInvoiceAddress2">
                      <ControlLabel>Address 2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceAddress2 ? this.state.invoiceAddress2 : ""}
                        placeholder="Address 2"
                        onChange={this.handleChange}
                        name="invoiceAddress2"
                        readOnly = "true"
                      />
                  </FormGroup>  
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        {/**end Company information **/}  

        {/**start invoices price information **/}
          <div className="panel">          
            <header className="panel-heading">
              Invoice Details{" "}
              <Button
                bsSize="small"
                onClick={this.addPricingDetail}
                bsStyle="success"
                className="pull-right"
              >
                Add Item
              </Button>
            </header>            
            <div className="panel-body">
              <div className="add-invoices col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formInvoiceDescription">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Description
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.invoiceDescription}
                        placeholder="Invoice Description"
                        onChange={this.handleChangeAditionalPrice}
                        name="invoiceDescription"
                        style={{ borderColor: this.state.invoiceDescriptionError }}
                      />
                    </FormGroup>                
                    
                    <ControlLabel>
                    <span style={{ color: "red" }}>*</span> Quantity
                    </ControlLabel>
                    <FormGroup controlId="formInvoiceQuantity">
                      <FormControl
                        type="number"
                        value={this.state.invoiceQuantity}
                        placeholder="Invoice Quantity"
                        onChange={this.handleChangeAditionalPrice}
                        name="invoiceQuantity"
                        style={{ borderColor: this.state.invoiceQuantityError }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={6} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Price
                    </ControlLabel>
                    <FormGroup controlId="formInvoicePrice">
                      <FormControl
                        type="number"
                        value={this.state.invoicePrice}
                        placeholder="Invoice Price"
                        onChange={this.handleChangeAditionalPrice}
                        name="invoicePrice"
                        style={{ borderColor: this.state.invoicePriceError }}
                      />
                    </FormGroup>

                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Total Amount
                    </ControlLabel>
                    <FormGroup controlId="formtotalInvoiceAmt">
                      <FormControl
                        type="number"
                        value={ parseFloat(this.state.totalInvoiceAmt).toFixed(2) }
                        placeholder="Invoice Amount"
                        onChange={this.handleChangeAditionalPrice}
                        name="totalInvoiceAmt"
                        style={{ borderColor: this.state.totalInvoiceAmtError }}
                        readOnly = "true"
                      />
                    </FormGroup>                     
                  </Col>
                </Row>
                <Row>
                  
                </Row>
              </div>
            </div>
          </div>
          {this.state.priceIndex.map((price, idx) => price)}
          {/**end invoices price information **/}
          
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="sendMail"
                data-key="sendMail"
                disabled={this.state.disabled}
                onClick={this.handleSubmit}
              >
                Send Mail
              </Button>
              <Button
              bsStyle="info"
              type="submit"
              id="saveDraft"
              data-key="saveDraft"
              disabled={this.state.disabled}
              onClick={this.handleDraft}
              >
              Save As Draft
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/invoices`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  invoicesDetails: state.invoicesReducers.invoicesDetails,
  error: state.invoicesReducers.error,
  fetchInvoices: state.invoicesReducers.fetchInvoices,
  sendingInvoicesData: state.invoicesReducers.sendingInvoicesData,
  invoicesResponse: state.invoicesReducers.invoicesResponse,
  invoicesUpdate: state.invoicesReducers.invoicesUpdate,
  siteList: state.invoicesReducers.siteList,
  siteDetails: state.invoicesReducers.siteDetails,
  sendingSiteDetails: state.invoicesReducers.sendingSiteDetails,
  alertType: state.alertsReducer.alertType
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    addInvoices,
    getInvoicesDetails,
    updateInvoices,
    getSiteList,
    get_site_details_id,
    renderAlert,
    clearAlert
  })
)(AddInvoices);


// WEBPACK FOOTER //
// ./src/app/views/invoices/AddInvoices.js